import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TournamentWidgetComponent } from './tournament-widget.component';
import { ButtonModule, ProgressModule, SvgIconModule, UtilsModule } from '@mtgame/ui';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { TournamentPlayoffWidgetModule } from '../tournament-playoff-widget/tournament-playoff-widget.module';
import { GroupItemComponent } from './group-item/group-item.component';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    ProgressModule,
    UtilsModule,
    RouterModule,
    SharedModule,
    TournamentPlayoffWidgetModule,
    ButtonModule
  ],
  declarations: [
    TournamentWidgetComponent,
    GroupItemComponent
  ],
  exports: [
    TournamentWidgetComponent,
  ]
})
export class TournamentWidgetModule {}
